import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    getPoolTypeById,
    updatePoolType
} from 'adminApi/PoolTypeApi/PoolType';
import { validateForm } from "utils/validation";
import { PoolTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPoolTypeForm from "./Components/EditPoolTypeForm";
import fields from "../json/PoolTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditPoolType = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        PoolTypeRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        getPoolTypeById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await updatePoolType({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, PoolTypeRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Pool Type updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <EditPoolTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Pool Type Detail"
            />
        </>
    );
};

export default EditPoolType;
